import { NavLink, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../router/routes";
import { ReactComponent as LogoHome } from '../../../assets/svg/home.svg';
import { ReactComponent as LogoMolecule } from '../../../assets/svg/molecule.svg';
import { ReactComponent as LogoSymptome } from '../../../assets/svg/symptome.svg';
import { ReactComponent as LogoEntrainemnt } from '../../../assets/svg/entrainement.svg';
import { ReactComponent as LogoInformations } from '../../../assets/svg/information.svg';
import styled from "styled-components";
import labels from '../../../_translations/locals.json';
import homeLabel from '../../../_translations/accueil.json';
import store from "../../../_services/store";
import { COLORS } from "../../../constants";
import { observer } from "mobx-react";

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    &.active {
    color: ${COLORS.WHITE};
  }
    width: 30px;
    height: 30px;
  }
`;

const NavbarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 10px;
  //height: 50vh;
`;

const LateralContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  //height: 100svh;
  padding: 100px 40px;
`;

const NavbarText = styled.span`
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  margin-left: 10px;
`;

const LinkElem = styled(NavLink)`
  &.active {
    color: ${props => props.theme.orange};
    border-radius: 10px;
    color: ${COLORS.WHITE};
    background: ${COLORS.PRIMARY};
  }
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  color: ${COLORS.DARK};
  background: transparent;
  padding: 10px;
`;

const Navbar = observer( () => {  
  const navigate = useNavigate();
  const menu = (
    <>
    <LinkElem
        key={"HOME"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none" }}
        to={ROUTES.HOME()}
      >
        <TitleContainer>
          <LogoHome fill={COLORS.DARK} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.home}</NavbarText>
        </TitleContainer>
      </LinkElem >
      <LinkElem
        key={"MOLECULES"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none" }}
        to={ROUTES.MOLECULES()}
      >
        <TitleContainer>
          <LogoMolecule fill={COLORS.DARK} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.accueil}</NavbarText>
        </TitleContainer>
      </LinkElem >

      <LinkElem
        key={"SYMPTOMES"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none" }}
        to={ROUTES.SYMPTOMS()}
      >
        <TitleContainer>
          <LogoSymptome fill={COLORS.DARK} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.tab1}</NavbarText>
        </TitleContainer>
      </LinkElem >

      <LinkElem
        key={"ENTRAINEMENT"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none" }}
        to={ROUTES.TRAINING()}
      >
        <TitleContainer>
          <LogoEntrainemnt fill={COLORS.DARK} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.tab2}</NavbarText>
        </TitleContainer>
      </LinkElem >

      <LinkElem
        key={"INFORMATIONS"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none" }}
        to={ROUTES.INFORMATIONS()}
      >
        <TitleContainer>
          <LogoInformations fill={COLORS.DARK} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.tab3}</NavbarText>
        </TitleContainer>
      </LinkElem >
    </>
  );

  return (
    <LateralContainer>
      <NavbarContainer>
        {menu}
      </NavbarContainer>
    </LateralContainer>
  )
})

export default Navbar;